import { request, requestRicerca } from "./interceptor";

/**
 * @function waferssServices hook that exposes the services to call
*/
const waferssServices = () => {

    /**
     * @function getContenuto Called that it returns the detail of a category by passing it the identifier
     * @param id category identifier
     * @returns {JSON}
    */
    const getContenuto = async ( id ) => {
        const res = request( { url: `/pubblica/contenuto/${ id }` } );
        return res;
    };

    /**
     * @function getMenuAll call that returns the menu to render in the application
     * @returns {JSON}
    */
    const getMenuAll = async () => {
        const res = request( { url: `/pubblica/menu/all` } );
        return res;
    };

    /**
     * @function getLinkImmagini call that returns the list of images that are displayed in the carousel
     * @returns {JSON}
    */
    const getLinkImmagini = async () => {
        const res = request( { url: `/pubblica/contenuto/linkImmagini` } );
        return res;
    };

      /**
     * @function getCheckPdf check the existence of the pdf
     * @returns {JSON}
    */
      const getCheckPdf = async (tipologia, params) => {
        const res = request( { url: `/assets/check/${ tipologia }`, params: params} );
        return res;
    };

    /**
     * @function getCheckPdf Download the pdf of the category
     * @returns {JSON}
    */
    const getPdfCategory = async (id, params) => {
        const res = request( { url: `/assets/downloadpdf/${ id }`, params: params } );
        return res;
    };

    /**
     * @function getCheckPdf recover the Archivi RSSR
     * @returns {JSON}
    */
        const getArchiviRSSR = async (params) => {
            const res = request( { url: `/assets/archivio` , params: params} );
            return res;
        };
    
     /**
     * @function getArticoloByTesto recover search results
     * @returns {JSON}
    */
     const getArticoloByTesto = async (params) => {
         const res = requestRicerca({ url: `/contenuto`, params: params });
        return res;
    };


    /**
     * @function getAnnoRelazione retrieves the year of the current RSSR
     * @returns {JSON}
    */
    const getAnnoRelazione = async (params) => {
        const res = request({ url: `/utilita/annoRelazione`, params: params });
        return res;
    };

    return {
        getContenuto,
        getMenuAll,
        getLinkImmagini,
        getCheckPdf,
        getPdfCategory,
        getArchiviRSSR,
        getArticoloByTesto,
        getAnnoRelazione
    };

};

export default waferssServices;
